<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="close"
      :title="$t('SeaExport.PickingList')"
      width="1000px"
      class="main-content"
    >
      <div class="warehousing-detail">
        <el-form
          ref="pickingOrderForm"
          :model="pickingOrder"
          label-width="100px"
          label-position="right"
          :show-message="false"
        >
          <el-collapse>
            <div class="section">
              <div class="form-row" style="display:flex;flex-direction:row;">
                <el-form label-width="100px" label-position="right" :disabled="true" style="margin-right:10px">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item :label="$t('SeaExport.Warehouse')">
                        <el-input v-model="pickingOrder.warehouseName" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.FreightStation')">
                        <el-input v-model="pickingOrder.deliveryStation" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.WarehouseEntrySerialNumber')">
                        <el-input v-model="pickingOrder.warehouseNo" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('SeaExport.MasterBillNo')">
                        <el-input v-model="pickingOrder.mbl" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.JobNo')">
                        <el-input v-model="pickingOrder.jobNo" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.PickingStatus')">
                        <el-select v-model="pickingOrder.pickingStatus">
                          <el-option :value="0" :label="$t('SeaExport.No')">{{ $t('SeaExport.No') }}</el-option>
                          <el-option :value="1" :label="$t('SeaExport.Yes')">{{ $t('SeaExport.Yes') }}</el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('SeaExport.CargoVehicle')">
                        <el-input v-model="pickingOrder.deliveryVehicle" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Driver')">
                        <el-input v-model="pickingOrder.driver" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Tel')">
                        <el-input v-model="pickingOrder.tel" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('SeaExport.PickingOrderNumber')">
                        <el-input v-model="pickingOrder.pickingOrderNo" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.Consignee')">
                        <el-input v-model="pickingOrder.consignee" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.DeliveryTime3')">
                        <el-input v-model="pickingOrder.deliveryTime" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('SeaExport.OutboundStatus')">
                        <el-select v-model="pickingOrder.outboundStatus">
                          <el-option :value="0" :label="$t('SeaExport.No')">{{ $t('SeaExport.No') }}</el-option>
                          <el-option :value="1" :label="$t('SeaExport.Yes')">{{ $t('SeaExport.Yes') }}</el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.OutboundUser')">
                        <el-input v-model="pickingOrder.outboundUser" />
                      </el-form-item>
                      <el-form-item :label="$t('Warehouse.DeliveryDate')">
                        <el-input v-model="pickingOrder.outboundTime" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('SeaExport.AssemblyPlanNumber')">
                        <el-input v-model="pickingOrder.assemlyPlanNo" />
                      </el-form-item>
                      <el-form-item :label="$t('SeaExport.OutboundRemarks')">
                        <el-input v-model="pickingOrder.outboundRemarks" type="textarea" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
            <div class="section">
              <span class="title">{{ $t('Warehouse.CargoDetails') }}</span>
              <div class="form-row grid-list">
                <el-form label-width="100px" label-position="left" :disabled="true" style="margin-right:10px">
                  <div>
                    <cargo-ag-grid
                      ref="goodsTable"
                      :grid-options="detailList.goodGridOptions"
                      :column-defs="goodsColumn"
                      :row-data="detailDatas || []"
                      style="height: 200px;"
                      @gridReady="params=>{detailList.gridApi=params.api}"
                    />
                    <el-form-item class="auto-width">
                      <div style="display: flex;text-align: left" class="title-row">
                        <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('CargoMsg.Cargo_NetGrossWeight') }}{{ openImperial ? '(LB)' : '(KG)' }}</div>
                        <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('CargoMsg.Cargo_GrossWeight2') + $t('CargoMsg.Cargo_Weight') }}</div>
                        <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }}{{ openImperial ? '(LB)' : '(KG)' }}</div>
                        <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
                        <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Cubage') }}{{ openImperial ? '(CFT)' : '(CBM)' }}</div>
                      </div>
                    </el-form-item>
                    <el-form-item :label="' '" class="auto-width">
                      <el-input-number v-show="!openImperial" v-model="pickingOrder.weightSum" no="weightSum" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                      <el-input-number v-show="openImperial" v-model="pickingOrder.weightSumImperial" no="weightSumImperial" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                      <el-input-number v-show="!openImperial" v-model="pickingOrder.grossWeightSum" no="grossWeightSum" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                      <el-input-number v-show="openImperial" v-model="pickingOrder.grossWeightSumImperial" no="grossWeightSumImperial" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                      <el-input-number v-show="!openImperial" v-model="pickingOrder.chargedWeightSum" no="chargedWeight" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                      <el-input-number v-show="openImperial" v-model="pickingOrder.chargedWeightSumImperial" no="chargedWeightSumImperial" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" />
                      <el-input-number v-model="pickingOrder.quantitySum" no="quantitySum" :disabled="true" controls-position="right" :min="0" :max="999999999" :precision="0" />
                      <el-input-number v-show="!openImperial" v-model="pickingOrder.cubageSum" no="cubageSum" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                      <el-input-number v-show="openImperial" v-model="pickingOrder.cubAgeSumImperial" no="cubAgeSumImperial" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" />
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
            <div class="section">
              <span class="title">{{ $t('Warehouse.CargoPhotos') }}</span>
              <div class="form-row grid-list">
                <el-form label-width="100px" label-position="left" :disabled="true" style="margin-right:10px">
                  <el-form class="spacing">
                    <el-upload
                      :action="`${URL.warehouseIn.uploadFileForPickingOrder}?saveFile=true&pickingOrderKey=${pickingOrder.uuid}`"
                      :headers="{sessionId:$store.getters.token}"
                      :show-file-list="false"
                      :on-success="uploadSuccess"
                      :on-change="toChooseFile"
                      style="display: inline-block;margin-right: 5px;"
                    >
                      <el-button no="42" type="primary">{{ $t('Warehouse.SelectFile') }}</el-button>
                    </el-upload>
                    <el-button type="danger" no="43" @click="delPhotoHandler">{{ $t('Warehouse.DeleteFile') }}</el-button>
                  </el-form>
                  <cargo-ag-grid
                    ref="photosList"
                    :grid-options="photoList.gridOptions"
                    :column-defs="photoList.photoColumn"
                    :row-data="documentDatas"
                    @gridReady="params=>{photoList.gridApi=params.api}"
                  />
                </el-form>
              </div>
            </div>
          </el-collapse>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { pickingOrderDetail, removeFileForPickingOrder } from '@/api/warehouseIn/warehouseIn'
import * as NumberUtils from '@/utils/NumberUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import { DocumentTypeUtil } from '@/class/cargo/model/utils/DocumentTypeUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'OutboundDetailDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    openImperial: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      detailList: {
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptions.selectedRowIndex = event.rowIndex
          }
        }
      },
      photoList: {
        gridApi: null,
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          selectedRowIndex: -1,
          context: {
            componentParent: this
          },
          columnApi: null
        },
        photoColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileName'),
            colId: 'fileName',
            field: 'fileName',
            width: 150,
            cellRenderer: params => {
              return `<a href="${URL.common.findByFileId}/${params.data.documentId}?sessionId=${this.$store.getters.userInfo.sessionId}" target="_blank" style="color:#46a6ff">${params.value}</a>`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileType'),
            colId: 'fileType',
            field: 'fileType',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileSize'),
            field: 'fileSize',
            width: 200,
            cellRenderer: params => {
              return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_UploadTime'), colId: 'dateCreated', field: 'dateCreated', width: 150 },
          { headerName: this.$t('SeaExport.DocumentType'), colId: 'fileCategory', field: 'fileCategory', width: 150,
            cellRenderer: params => {
              return this.documentTypeUtil.fileTypeLabelFunction(params.value)
            }
          }
        ]
      },
      pickingOrder: {
        uuid: '',
        warehouseName: '',
        mbl: '',
        deliveryStation: '',
        jobNo: '',
        driver: '',
        warehouseNo: '',
        pickingStatus: 0,
        tel: '',
        pickingOrderNo: '',
        outboundStatus: 0,
        outboundRemarks: '',
        assemlyPlanNo: '',
        consignee: '',
        deliveryTime: '',
        outboundUser: '',
        outboundTime: '',
        quantitySum: 0,
        weightSum: 0,
        cubageSum: 0,
        grossWeightSum: 0,
        chargedWeightSum: 0,
        chargedWeightSumImperial: 0.00,
        weightSumImperial: 0.00,
        cubAgeSumImperial: 0.000,
        grossWeightSumImperial: 0.000,
        palletSum: 0
      },
      documentDatas: [], // 文件列表
      detailDatas: [], // 文件列表
      innerVisible: false,
      documentManage: new DocumentManage(),
      documentTypeUtil: null,
      // 图片预览参数
      previewFileData: {
        visible: false,
        file: null
      },
      cWeightIsCeil: 0,
      URL: URL
    }
  },
  computed: {
    goodsColumn() {
      let list = [
        {
          headerName: this.$t('CargoMsg.Cargo_ScaleWeight'),
          field: 'weighbridgeWeight',
          colId: 'weighbridgeWeight',
          width: 120,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TareWeight'),
          field: 'tareWeight',
          colId: 'tareWeight',
          width: 120,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GrossWeight2'),
          field: 'grossWeight',
          colId: 'grossWeight',
          width: 120,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NetGrossWeight') + 'KGS',
          field: 'weight',
          colId: 'weight',
          width: 120,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_measurements'),
          field: 'dimension',
          colId: 'dimension',
          maxWidth: 500,
          minWidth: 300,
          cellRenderer: params => {
            let value = params.value
            if (value && value.length > 30) {
              value = value.substring(0, 29) + '...'
            }
            return value
          }
        },
        {
          headerName: this.$t('SeaExport.SingleWeight') + 'KGS',
          field: 'singleWeight',
          colId: 'singleWeight',
          width: 120,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage2'),
          field: 'cubage',
          colId: 'cubage',
          width: 150,
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
          }
        }
      ]

      if (this.openImperial) {
        list = [
          {
            headerName: this.$t('CargoMsg.Cargo_ScaleWeight') + '(LB)',
            field: 'weighbridgeWeightImperial',
            colId: 'weighbridgeWeightImperial',
            width: 120,
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TareWeight') + '(LB)',
            field: 'tareWeightImperial',
            colId: 'tareWeightImperial',
            width: 120,
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_GrossWeight2') + '(LB)',
            field: 'grossWeightImperial',
            colId: 'grossWeightImperial',
            width: 120,
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_NetGrossWeight') + '(LB)',
            field: 'weightImperial',
            colId: 'weightImperial',
            width: 120,
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_measurements2'),
            field: 'dimensionImperial',
            colId: 'dimensionImperial',
            maxWidth: 500,
            minWidth: 300,
            cellRenderer: params => {
              let value = params.value
              if (value && value.length > 30) {
                value = value.substring(0, 29) + '...'
              }
              return value
            }
          },
          {
            headerName: this.$t('SeaExport.SingleWeight') + '(LB)',
            field: 'singleWeightImperial',
            colId: 'singleWeightImperial',
            width: 120,
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Cubage') + '(CFT)',
            field: 'cubAgeImperial',
            colId: 'cubAgeImperial',
            width: 150,
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
            }
          }
        ]
      }
      list.push({
        headerName: this.$t('CargoMsg.Cargo_OurPallet'),
        field: 'palletNo',
        colId: 'palletNo',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PalletConfiguration, 'uuid', params.value, 'palletCode')
        }
      }, {
        headerName: this.$t('SeaExport.PackageType'),
        field: 'packing',
        colId: 'packing',
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.packingCodeLabelFun(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
        field: 'quantity',
        colId: 'quantity',
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remarks',
        colId: 'remarks',
        minWidth: 200
      },
      {
        headerName: this.$t('CargoMsg.Cargo_PalletNumber'),
        field: 'palletNumber',
        colId: 'palletNumber',
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Location2'),
        field: 'storageLocation',
        colId: 'storageLocation',
        valueFormatter: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_LocationConfiguration, 'uuid', params.value, 'locationCode')
        }
      })

      return list
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.documentTypeUtil = await DocumentTypeUtil.getInstance()
    },
    async onShow(pickingOrderKey = null) {
      await cache.load(cacheName.CONFIG)
      this.cWeightIsCeil = Number(cache.config.get('AEcWeightCeil')) // 计费重量是否取整
      if (pickingOrderKey) {
        this.loading = getLoading4Cxt()
        pickingOrderDetail({ pickingOrderKey: pickingOrderKey }).then(res => {
          if (res.data) {
            this.pickingOrder = res.data
            const documentDatas = []
            if (this.pickingOrder.businessDocuments) {
              for (const item of this.pickingOrder.businessDocuments) {
                documentDatas.push({ ...item })
              }
            }
            this.documentDatas = documentDatas
            const detailDatas = []
            if (this.pickingOrder.warehouseInDetails) {
              for (const item of this.pickingOrder.warehouseInDetails) {
                detailDatas.push({ ...item })
              }
            }
            this.detailDatas = detailDatas
            this.calcSum()
          }
        }).finally(res => {
          this.loading.close()
        })
      }
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    },
    async handlePreviewFile(value) {
      const fileObject = this.documentDatas.find(x => x.documentId === value)
      this.previewFileData.file = fileObject
      this.previewFileData.visible = true
    },
    // 计算
    async calcSum() {
      let quantitySum = 0
      let weightSum = 0
      let cubageSum = 0
      let grossWeightSum = 0
      let weightSumImperial = 0
      let cubAgeSumImperial = 0
      let grossWeightSumImperial = 0
      for (const detail of this.detailDatas) {
        quantitySum += detail.quantity
        weightSum += Number(detail.weight)
        cubageSum += Number(detail.cubage)
        grossWeightSum += Number(detail.grossWeight)

        weightSumImperial += Number(detail.weightImperial)
        cubAgeSumImperial += Number(detail.cubAgeImperial)
        grossWeightSumImperial += Number(detail.grossWeightImperial)
      }
      this.pickingOrder.quantitySum = quantitySum
      this.pickingOrder.weightSum = weightSum
      this.pickingOrder.cubageSum = cubageSum
      this.pickingOrder.grossWeightSum = grossWeightSum
      this.pickingOrder.chargedWeightSum = JobUtils.calcChargeWeight(this.pickingOrder.weightSum, this.pickingOrder.cubageSum, true, this.cWeightIsCeil)

      this.pickingOrder.weightSumImperial = weightSumImperial
      this.pickingOrder.cubAgeSumImperial = cubAgeSumImperial
      this.pickingOrder.grossWeightSumImperial = grossWeightSumImperial
      this.pickingOrder.chargedWeightSumImperial = await JobUtils.calculateWeight(this.pickingOrder.chargedWeightSum, true)
      this.pickingOrder.palletSum = this.detailDatas.length
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(this.$t('Message.TheExceeds20MBAndUploaded'))
        return
      }
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        const document = {}
        document.uuid = ''
        document.businessId = response.data.businessId
        document.createdBy = response.data.createdBy
        document.dateCreated = response.data.dateCreated
        document.documentCategory = response.data.documentCategory
        document.documentId = response.data.documentId
        document.fileName = response.data.fileName
        document.fileSize = response.data.fileSize
        document.fileType = response.data.fileType
        document.fileCategory = response.data.fileCategory
        document.newData = true
        this.documentDatas.push(document)
      } else {
        this.$message.warning(this.$t('Message.UploadPleaseContactTheAdministrator'))
      }
    },
    // 删除文件
    delPhotoHandler() {
      const rows = this.photoList.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.loading = getLoading4Cxt()
      const fileIds = []
      rows.forEach(item => { fileIds.push(item.documentId) })
      removeFileForPickingOrder([...fileIds]).then(res => {
        if (res.ok) {
          this.$message.success(this.$t('SeaExport.DeleteSucceeded'))
        }
      }).finally(res => {
        this.loading.close()
      })
      for (const row of rows) {
        const index = this.documentDatas.indexOf(row)
        this.documentDatas.splice(index, 1)
      }
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
</style>
